<script>
    import { fly } from "svelte/transition";
    import { Grid, GridItem } from "../index";
</script>

<div class="example" transition:fly={{ x: 200 }}>
    <h4 class="example-title">基础用法</h4>
    <div class="example-body">
        <Grid columns={3} gap={8}>
            <GridItem><div class="item item1">A</div></GridItem>
            <GridItem><div class="item item2">B</div></GridItem>
            <GridItem><div class="item item3">C</div></GridItem>
            <GridItem><div class="item item4">D</div></GridItem>
            <GridItem><div class="item item5">E</div></GridItem>
        </Grid>
    </div>
    <h4 class="example-title">控制格子的跨度</h4>
    <div class="example-body">
        <Grid columns={3} gap={8}>
            <GridItem>
                <div class="item item1">A</div>
            </GridItem>
            <GridItem span={2}><div class="item item2">B</div></GridItem>
            <GridItem span={2}><div class="item item3">C</div></GridItem>
            <GridItem><div class="item item4">D</div></GridItem>
            <GridItem span={3}><div class="item item5">E</div></GridItem>
        </Grid>
    </div>
    <h4 class="example-title">自定义css变量</h4>
    <div class="example-body">
        <Grid --columns={3} --gap-horizontal={"16px"} --gap-vertical={"24px"}>
            <GridItem>
                <div class="item item1">A</div>
            </GridItem>
            <GridItem span={2}><div class="item item2">B</div></GridItem>
            <GridItem span={2}><div class="item item3">C</div></GridItem>
            <GridItem><div class="item item4">D</div></GridItem>
            <GridItem span={3}><div class="item item5">E</div></GridItem>
        </Grid>
    </div>
</div>

<style lang="less">
    @import "./example.less";
    .item {
        border: 1px solid #ccc;
        text-align: center;
        background-color: #f5f5f5;
        color: #999;
    }
</style>
